import { useRef } from 'react'
import { useTranslation } from 'react-i18next'

import {
  deleteRentalPortalListingPhoto,
  getRentalPortalListing,
} from '../../../../../../api'
import { LISTING_FORM_FIELD_NAME_PHOTOS } from '../../../../../RentalPortalListing'
import {
  getRentalPortalListingPhotosState,
  saveRentalPortalListingPhotos,
} from '../../../../RentalPortalPhotoGallery'
import { setListingFormSubmitError } from '../../RentalPortalListingsForm.utils'

export function useRentalPortalListingsFormPhotos({
  formInitialValues,
  savedListingId,
  onChangeVersion,
}) {
  const { t } = useTranslation()

  const savedPhotosRef = useRef(null)

  function getSavedPhotos() {
    return (
      savedPhotosRef.current ??
      formInitialValues[LISTING_FORM_FIELD_NAME_PHOTOS]
    )
  }

  async function refreshRecordVersion() {
    const { data } = await getRentalPortalListing(savedListingId)

    onChangeVersion(data.version)
  }

  async function handleDeletePhoto(fileId) {
    await deleteRentalPortalListingPhoto({ fileId, id: savedListingId })

    await refreshRecordVersion().catch(console.error)
  }

  async function syncPhotosWithListing({ record, setFormikState, values }) {
    const state = await getRentalPortalListingPhotosState({
      listingId: record.id,
      photos: values[LISTING_FORM_FIELD_NAME_PHOTOS],
    })

    savedPhotosRef.current = state.savedPhotos

    onChangeVersion(state.version)

    setFormikState(formikState => ({
      ...formikState,
      values: {
        ...formikState.values,
        [LISTING_FORM_FIELD_NAME_PHOTOS]: state.photos,
      },
    }))
  }

  async function saveListingPhotos({ formikHelpers, record, values }) {
    const { setErrors, setFormikState, setSubmitting } = formikHelpers

    try {
      const hasPhotoWrites = await saveRentalPortalListingPhotos({
        listingId: record.id,
        photos: values[LISTING_FORM_FIELD_NAME_PHOTOS],
        savedPhotos: getSavedPhotos(),
      })

      if (hasPhotoWrites) {
        await syncPhotosWithListing({ record, setFormikState, values })
      }

      return true
    } catch {
      await syncPhotosWithListing({ record, setFormikState, values }).catch(
        console.error
      )

      setListingFormSubmitError({
        errorText: t('RentalPortal.ListingFormPhotosErrorKey'),
        setErrors,
        setSubmitting,
      })

      return false
    }
  }

  function resetSavedPhotos() {
    savedPhotosRef.current = null
  }

  return { handleDeletePhoto, resetSavedPhotos, saveListingPhotos }
}
